import { Injectable } from "@angular/core";
import { SvgIconRegistryService } from "angular-svg-icon";

@Injectable({
  providedIn: "root"
})
export class IconRegistryService {
  constructor(private iconRegistry: SvgIconRegistryService) {}

  private icons: { path: string; name: string }[] = [
    { path: "download.svg", name: "download" },
    { path: "dashboard-logo.svg", name: "dashboard-logo" },
    { path: "bin.svg", name: "bin" },
    { path: "pen.svg", name: "pen" },
    { path: "plus.svg", name: "plus" },
    { path: "magnifying-glass.svg", name: "magnifying-glass" },
    { path: "filter.svg", name: "filter" },
    { path: "upload.svg", name: "upload" },
    { path: "right-triangle.svg", name: "right-triangle" },
    { path: "left-triangle.svg", name: "left-triangle" },
    { path: "map.svg", name: "map" },
    { path: "go-to-list.svg", name: "go-to-list" },
    { path: "arrow-right.svg", name: "arrow-right" },
    { path: "arrow-left.svg", name: "arrow-left" },
    { path: "calendar.svg", name: "calendar" },
    { path: "chevron-down.svg", name: "chevron-down" },
    { path: "copy.svg", name: "copy" },
    { path: "check.svg", name: "check" },
    { path: "device-state-pin.svg", name: "device-state-pin" },
    { path: "chevron-left.svg", name: "chevron-left" },
    { path: "chevron-end-left.svg", name: "chevron-end-left" },
    { path: "chevron-right.svg", name: "chevron-right" },
    { path: "chevron-end-right.svg", name: "chevron-end-right" },
    { path: "wifi.svg", name: "wifi" },
    { path: "no-wifi.svg", name: "no-wifi" },
    { path: "radio.svg", name: "radio" },
    { path: "battery/battery-1.svg", name: "battery-1" },
    { path: "battery/battery-2.svg", name: "battery-2" },
    { path: "battery/battery-3.svg", name: "battery-3" },
    { path: "battery/battery-4.svg", name: "battery-4" },
    { path: "device.svg", name: "device" },
    { path: "graph.svg", name: "graph" },
    { path: "info.svg", name: "info" },
    { path: "pallet.svg", name: "pallet" },
    { path: "help.svg", name: "help" },
    { path: "last-site.svg", name: "last-site" },
    { path: "next-site.svg", name: "next-site" },
    { path: "radius.svg", name: "radius" },
    { path: "site.svg", name: "site" },
    { path: "slider.svg", name: "slider" },
    { path: "warn.svg", name: "warn" },
    { path: "container.svg", name: "container" },
    { path: "add-incident.svg", name: "add-incident" },
    { path: "incident.svg", name: "incident" },
    { path: "color-status.svg", name: "color-status" },
    { path: "close.svg", name: "close" },
    { path: "satellite.svg", name: "satellite" },
    { path: "small-cancel.svg", name: "small-cancel" },
    { path: "reference.svg", name: "reference" },
    { path: "token.svg", name: "token" },
    { path: "user.svg", name: "user" },
    { path: "group.svg", name: "group" },
    { path: "torn.svg", name: "torn" },
    { path: "unknown.svg", name: "unknown" },
    { path: "delete.svg", name: "delete" },
    { path: "switch.svg", name: "switch" },
    { path: "maximize.svg", name: "maximize" },
    { path: "devices-types.svg", name: "devices-types" },
    // kpi status:
    { path: "kpi/status/green.svg", name: "green" },
    { path: "kpi/status/blue.svg", name: "blue" },
    { path: "kpi/status/orange.svg", name: "orange" },
    { path: "kpi/status/red.svg", name: "red" },
    { path: "kpi/status/grey.svg", name: "grey" },
    { path: "kpi/status/static.svg", name: "detail-static" },
    // kpi battery
    { path: "kpi/battery/battery-excellent.svg", name: "excellent" },
    { path: "kpi/battery/battery-good.svg", name: "good" },
    { path: "kpi/battery/battery-medium.svg", name: "almostEmpty" },
    { path: "kpi/battery/battery-almost-empty.svg", name: "empty" },
    { path: "kpi/battery/battery-empty.svg", name: "offline" },
    { path: "kpi/battery/battery-torn.svg", name: "detail-torn" },
    { path: "kpi/battery/battery-quiet.svg", name: "detail-quiet" },
    //kpi mist
    { path: "kpi/misc/kpi-alert-site.svg", name: "alert-site" },
    { path: "kpi/misc/kpi-incident.svg", name: "kpi-incident" },
    // flags
    { path: "flags/gb.svg", name: "flag-en" },
    { path: "flags/fr.svg", name: "flag-fr" },
    { path: "flags/de.svg", name: "flag-de" },
    { path: "flags/it.svg", name: "flag-it" }
  ];

  public loadIcons(): void {
    this.icons.forEach((icon) => {
      const iconPath = `../../assets/img/${icon.path}`;
      this.iconRegistry.loadSvg(iconPath, icon.name).subscribe();
    });
  }
}
